import React from "react";
import mapIcon from "@/assets/images/map-icon.png";
import { useTranslation } from "react-i18next";
import { storageServerPath } from "../../utils/server/api";
import { Property } from "@/models/Property";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const PropertyMetaInfo = ({
  propertyId,
  property,
  propertyStatus,
  setOpenModalArchive,
  setOpenModalUnarchive,
  setOpenModalDelete,
  setOpenModalAddToCart,
}: {
  propertyId: string;
  property: Property;
  propertyStatus: Boolean;
  setOpenModalArchive: () => void;
  setOpenModalUnarchive: () => void;
  setOpenModalDelete: () => void;
  setOpenModalAddToCart: () => void;
}) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useTranslation();

  const MetaItem = ({
    onClick,
    children,
    className = "",
  }: {
    onClick?: () => void;
    children: React.ReactNode;
    className?: string;
  }) => (
    <div
      onClick={onClick}
      className={`flex items-center justify-center px-5 py-2 rounded-lg cursor-pointer bg-gray-200 transition duration-200 ${className}`}
    >
      {children}
    </div>
  );

  const openMap = () => {
    navigate(`/satelite?lat=${property?.lat}&lng=${property?.lng}`);
  };

  const setOpenContract = () => {
    navigate(`/contract/${propertyId}`);
  };

  return (
    <div className="flex flex-wrap gap-4">
      <MetaItem onClick={openMap} className="text-[#50700f]">
        <img src={mapIcon} alt="Map Icon" className="w-auto !h-[30px] mr-2" />
        <p>{t("map-track")}</p>
      </MetaItem>
      {property.status !== "catalog" && (
        <>
          {property.file_cib !== null && (
            <MetaItem
              className="text-[#50700f]"
              onClick={() => window.open(storageServerPath + property.file_cib)}
            >
              <p>{t("cib-file")}</p>
            </MetaItem>
          )}
          {property.file_deed_number !== null && (
            <MetaItem
              className="text-[#50700f]"
              onClick={() =>
                window.open(storageServerPath + property.file_deed_number)
              }
            >
              <p>{t("deed-file")}</p>
            </MetaItem>
          )}
          {property.file_proof_of_residence !== null && (
            <MetaItem
              className="text-[#50700f]"
              onClick={() =>
                window.open(
                  storageServerPath + property.file_proof_of_residence
                )
              }
            >
              <p>{t("proof-residence")}</p>
            </MetaItem>
          )}
        </>
      )}
      {user?.user_type === "seller" &&
        user?.id === property?.user_id &&
        (property?.status === "active_certified" ||
          property?.status === "active") && (
          <MetaItem
            className="bg-orange-400"
            onClick={() => setOpenModalArchive()}
          >
            <p style={{ color: "#fff", fontWeight: "bold" }}>{t("archive")}</p>
          </MetaItem>
        )}

      {user?.user_type === "seller" &&
        user?.id === property?.user_id &&
        property?.status === "archived" && (
          <MetaItem
            className="bg-orange-400"
            onClick={() => setOpenModalUnarchive()}
          >
            <p style={{ color: "#fff", fontWeight: "bold" }}>{t("archived")}</p>
          </MetaItem>
        )}
      {user?.user_type === "seller" &&
        property?.user_id === user?.id &&
        property?.engineer_update !== 1 && (
          <MetaItem
            className="!bg-blue-600"
            onClick={() => navigate(`/updateProperty/${property.id}`, {
              state: {readonly: false, isEditing: true}
            })}
          >
            <p
              style={{
                color: "#fff",
                fontWeight: "bold",
              }}
            >
              {t("edit")}
            </p>
          </MetaItem>
        )}
      {user?.user_type === "seller" &&
        property?.status !== "active" &&
        property?.status !== "archived" &&
        property?.status !== "active_certified" &&
        property?.user_id === user?.id && (
          <>
            <MetaItem
              className="bg-red-600"
              onClick={() => {
                setOpenModalDelete();
              }}
            >
              <p
                style={{
                  color: "#fff",
                  fontWeight: "bold",
                }}
              >
                {t("delete")}
              </p>
            </MetaItem>
            {propertyStatus === false && (
              <MetaItem
                className="bg-yellow-500"
                onClick={() => {
                  setOpenContract();
                }}
              >
                <p
                  style={{
                    color: "#000",
                    fontWeight: "bold",
                  }}
                >
                  {t("contracts")}
                </p>
              </MetaItem>
            )}
          </>
        )}
      {user?.user_type === "engineer" &&
        property?.engineer_connect === user?.id && (
          <MetaItem
            className="!bg-[#aa6e00]"
            onClick={() => {
              navigate(`/report-upload/${property.id}`);
            }}
          >
            <p style={{ color: "#fff", fontWeight: "bold" }}>Subir laudo</p>
          </MetaItem>
        )}
      {/*user?.user_type === "buyer" && user?.trial_period === false &&
                                property.carbon_credits_available > 0 &&
                                property.status === "active" &&*/}
      {user?.user_type === "buyer" &&
        property.carbon_credits_available > 0 &&
        property.status === "active" && (
          <MetaItem
            onClick={() => setOpenModalAddToCart()}
            className="!bg-[#658C39] text-white font-bold"
          >
            <p>{t("add-to-cart")}</p>
          </MetaItem>
        )}
      {user?.user_type === "buyer" &&
        user?.trial_period === false &&
        property.carbon_credits_available <= 0 && (
          <MetaItem className="bg-gray-500">
            <p
              style={{
                color: "#fff",
                fontWeight: "bold",
              }}
            >
              {t("unavailable")}
            </p>
          </MetaItem>
        )}
      {/*user?.trial_period === true && (
                <MetaItem className="bg-orange-400">
                  <p
                    style={{
                      color: "#fff",
                      fontWeight: "bold",
                    }}
                  >
                    {t("trial_period")} {user?.test_time}
                  </p>
                </MetaItem>
              )*/}
    </div>
  );
};

export default PropertyMetaInfo;
